module.exports = __webpack_public_path__ + "static/media/ratchet-and-clank.b27f58d7.webp";